import * as React from 'react'
import Image from 'next/image'
import { Link } from '@repo/web-ui/components/link'

import type { SocialListPostByProductQuery } from '@web/gen/feed-post'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { Typography } from '@repo/design-system-cf/components/typography'
import { IconComment, IconFavoriteBorder } from '@repo/design-system-cf/components/icons'
import { convertHighCount } from '@web/utils/counter'
import { Link as DsLink } from '@repo/design-system-cf/components/link'
import { useLocale } from 'next-intl'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'

interface SlideProps {
  post: SocialListPostByProductQuery['socialListPostByProduct']['Posts'][0]
}

// oxlint-disable-next-line complexity
export function Slide({ post }: SlideProps) {
  const locale = useLocale()
  const url = addOrReplaceLocaleInUrl(`${AppRoutes.SOCIAL_CURATED_FEED}${post?.postSlug}`, locale)

  const displayName = post?.user?.firstName
    ? `${post?.user?.firstName} ${post?.user?.lastName || ''}`
    : post?.user?.displayName

  return (
    <Link href={url} className="group relative inline-block snap-start" target="_blank">
      <Image
        src={post?.assets?.[0]?.url ?? ''}
        alt={post?.assets?.[0]?.type ?? ''}
        width={240}
        height={240}
        className="rounded-4 bg-cf-dreamy-cloud-400 h-[240px] w-auto max-w-60 scale-[0.98] transform-gpu object-cover transition-transform duration-300 ease-in-out group-hover:scale-100 mb-2"
      />
      <div className="flex flex-col gap-1 pl-1 ">
        <DsLink
          href={addOrReplaceLocaleInUrl(post?.user?.profileUrls?.crafter ?? '', locale)}
          variant={'subtle'}
          className="font-normal"
          target="_blank"
        >
          <Typography
            variant={'cf-label-02'}
            className="truncate max-w-60"
            title={`By ${displayName}`}
          >
            By {displayName}
          </Typography>
        </DsLink>
        <div className="flex items-center gap-1 text-cf-grey-900">
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-1">
              <IconFavoriteBorder className="w-4 h-4" />
              <Typography variant={'cf-label-02'} className="">
                {convertHighCount(post?.likesCount ?? 0)}
              </Typography>
            </div>
            <div className="flex items-center gap-1">
              <IconComment className="w-4 h-4" />
              <Typography variant={'cf-label-02'} className="">
                {convertHighCount(post?.commentsCount ?? 0)}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
